import { BRAND_INDIGO, ICON_SHAPES, type IconVariant } from './brand-icon.ts'
import { cx } from './cx.ts'

// SVG attribute names (stroke-width) to React's (strokeWidth).
const camel = (name: string) => name.replace(/-(\w)/g, (_, c: string) => c.toUpperCase())

/**
 * The Sano Godam icon (a warehouse with a parcel, beside a receipt) as an
 * inline SVG. Uses the simplified "small" drawing below 48 px.
 */
export function BrandMark({ size = 32, className }: { size?: number; className?: string }) {
  const variant: IconVariant = size < 48 ? 'small' : 'master'
  return (
    <svg
      viewBox="0 0 256 256"
      width={size}
      height={size}
      aria-hidden
      className={cx('shrink-0', className)}
    >
      <rect width="256" height="256" rx="56" fill={BRAND_INDIGO} />
      {ICON_SHAPES[variant].map(([Tag, attrs], i) => (
        <Tag
          key={i}
          {...Object.fromEntries(Object.entries(attrs).map(([k, v]) => [camel(k), v]))}
        />
      ))}
    </svg>
  )
}
